import React, { useState } from "react";
import { Box, TextField, IconButton, Alert } from "@mui/material";
import { Send } from "@mui/icons-material";

export const ChatInput = ({
  onSend,
  disabled,
  usageStats,
  allowCreation = false,
}) => {
  const [inputValue, setInputValue] = useState("");

  const isLimitReached = usageStats?.limitReached || false;
  const isDisabled = disabled || (isLimitReached && !allowCreation);

  const handleSend = () => {
    if (inputValue.trim() && !isDisabled) {
      onSend(inputValue.trim());
      setInputValue("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const placeholder = allowCreation
    ? "Ask Bud a question or describe an assignment or quiz..."
    : isLimitReached
      ? "Weekly limit reached - Upgrade to continue"
      : "Ask me about your class data...";

  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        borderTop: 1,
        borderColor: "divider",
        backgroundColor: "background.paper",
      }}
    >
      {isLimitReached && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          You've reached your weekly limit of {usageStats.responseLimit} AI
          responses.{" "}
          {allowCreation
            ? "You can still create assignments and quizzes within your creation limits."
            : "Upgrade to continue using the assistant."}
        </Alert>
      )}

      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          fullWidth
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          disabled={isDisabled}
          variant="outlined"
          size="small"
          sx={{
            "& .MuiOutlinedInput-root input::placeholder": {
              color: "text.secondary",
              opacity: 0.7,
            },
          }}
        />
        <IconButton
          color="primary"
          onClick={handleSend}
          disabled={isDisabled || !inputValue.trim()}
        >
          <Send />
        </IconButton>
      </Box>
    </Box>
  );
};
